import LeadStatus from "../../../model/lead/LeadStatus";
import LeadStatusSettings from "../../../model/lead/LeadStatusSetting";

/**
 * Lead statuses fetched successful action.
 */
export const LEAD_STATUSES_FETCHED = "LEAD_STATUSES_FETCHED";
export type LEAD_STATUSES_FETCHED = { leadStatuses: Array<LeadStatus> }

/**
 *  Update lead status sort order successful action.
 */
export const LEAD_STATUS_SORT_ORDER_UPDATED = "LEAD_STATUS_SORT_ORDER_UPDATED";
export type LEAD_STATUS_SORT_ORDER_UPDATED = { leadStatuses: Array<LeadStatus> }

/**
 * Edit lead status successful action.
 */
export const LEAD_STATUS_EDITED = "LEAD_STATUS_EDITED";
export type LEAD_STATUS_EDITED = { leadStatus: LeadStatus }

/**
 * Lead statuses config fetched successful action.
 */
export const LEAD_STATUS_CONFIG_FETCHED = "LEAD_STATUS_CONFIG_FETCHED";
export type LEAD_STATUS_CONFIG_FETCHED = { leadStatusConfig: Array<LeadStatusSettings> }

/**
 * Update lead status config successful action.
 */
export const LEAD_STATUS_CONFIG_EDITED = "LEAD_STATUS_CONFIG_EDITED";
export type LEAD_STATUS_CONFIG_EDITED = { leadStatusConfig: LeadStatusSettings }

